export default function () {
  const mobileNavContainer = document.getElementById('wc-mobile-nav-container');
  const mobileMenuContainer = document.getElementById('wc-mobile-menu-container');
  const mobileMenu = document.getElementById('wc-mobile-menu');
  const mobileMenuButton = document.getElementById('wc-mobile-menu-button');
  const mobileCloseButton = document.getElementById('wc-mobile-close-button');

  if (!mobileNavContainer || !mobileMenuContainer || !mobileMenu || !mobileMenuButton || !mobileCloseButton) {
    return;
  }

  let menuToggled = false;

  function toggleMenu (shouldClose = null)  {
    const isToggled = shouldClose ? shouldClose : menuToggled;
    menuToggled = !isToggled;

    isToggled
      ? mobileMenuContainer.setAttribute('inert', '')
      : mobileMenuContainer.removeAttribute('inert');

    mobileNavContainer.setAttribute('data-mobile-menu-toggled', `${!isToggled}`);
    mobileMenuButton.setAttribute('aria-expanded', `${!isToggled}`);
    mobileMenuContainer.setAttribute('aria-hidden', `${isToggled}`);
  }

  document.addEventListener('click', (event) => {
    if (mobileMenu.contains(event.target)) toggleMenu(true);
    if (mobileNavContainer.contains(event.target)) return;

    toggleMenu(true);
  });

  mobileMenuContainer.addEventListener('focusout', (event) => {
    if (mobileNavContainer.contains(event.relatedTarget)) return;

    toggleMenu(true);
  });

  document.addEventListener('keydown', (event) => {
    if (!menuToggled) return;
    if (event.key !== 'Escape') return;

    toggleMenu(true);
    mobileMenuButton.focus();
  });

  mobileMenuButton.addEventListener('click', () => toggleMenu());
  mobileCloseButton.addEventListener('click', () => toggleMenu(true));
}
